export const KEY_PREFERENCES = "userPreferences";

export const SUPPORTED_LANGUAGES = ["en", "fr", "nl"];

export function detectBrowserLanguage() {
    const navigatorLocale = (navigator.language || (navigator.languages || [])[0] || "").trim();
    const code = navigatorLocale.split(/-|_/)[0].toLowerCase();
    return SUPPORTED_LANGUAGES.includes(code) ? code : "en";
}

export const PREFERENCE_DEFINITIONS = [
    {
        id: "sideNavAlwaysExpanded",
        type: "boolean",
        title: "preferencesPage.sideNavAlwaysExpanded",
        tooltip: "preferencesPage.sideNavAlwaysExpandedTooltip",
        defaultValue: false,
        hiddenOnPhone: true,
    },
    {
        id: "language",
        type: "select",
        title: "preferencesPage.language",
        tooltip: "preferencesPage.languageTooltip",
        defaultValue: "auto",
        options: [
            {value: "auto", label: "preferencesPage.languageAuto"},
            {value: "en", label: "preferencesPage.languageEn"},
            {value: "fr", label: "preferencesPage.languageFr"},
            {value: "nl", label: "preferencesPage.languageNl"},
        ],
    },
    {
        id: "showTableIds",
        type: "boolean",
        title: "preferencesPage.showTableIds",
        tooltip: "preferencesPage.showTableIdsTooltip",
        defaultValue: false,
        superUserOnly: true,
    },
    {
        id: "favoriteLinks",
        type: "navLinks",
        title: "preferencesPage.favoriteLinks",
        tooltip: "preferencesPage.favoriteLinksTooltip",
        defaultValue: [],
    },
];

export class PreferencesHelper {

    static visibleDefinitions(isPhone, isSuperUser = false) {
        return PREFERENCE_DEFINITIONS.filter((definition) => {
            if (definition.hiddenOnPhone && isPhone) return false;
            if (definition.superUserOnly && !isSuperUser) return false;
            return true;
        });
    }

    static defaults() {
        return PREFERENCE_DEFINITIONS.reduce((acc, definition) => {
            acc[definition.id] = definition.defaultValue;
            return acc;
        }, {});
    }

    static load() {
        const defaults = PreferencesHelper.defaults();
        try {
            const stored = JSON.parse(localStorage.getItem(KEY_PREFERENCES) || "{}");
            return {...defaults, ...(stored || {})};
        } catch (e) {
            return defaults;
        }
    }

    static save(preferences) {
        localStorage.setItem(KEY_PREFERENCES, JSON.stringify(preferences || {}));
    }

    static raw() {
        return localStorage.getItem(KEY_PREFERENCES);
    }

    static restore(raw) {
        if (raw != null) {
            localStorage.setItem(KEY_PREFERENCES, raw);
        }
    }
}
